import React from "react";

import { NonEmptyArray } from "fp-ts/es6/NonEmptyArray";
import { ImageCarouselComponentHeadline } from "../_shared-components/ui-elements/SwarovskiGenericCarouselComponent/ImageCarouselComponentHeadline";
import { DownloadsCarouselElem, type TranslatedValue } from "@swo/storefront";
import { ContentContainer } from "../_shared-components/arrangement/Container";
import { PDPDownloadElements } from "./PDPDownloadElements";
import { T } from "../T";

export function PDPDownloadsComponent(props: {
  headline: TranslatedValue | undefined;
  elements: NonEmptyArray<DownloadsCarouselElem>;
}) {
  return (
    <ContentContainer>
      {props.headline && (
        <ImageCarouselComponentHeadline className={"u-uppercase"}>
          <T>{props.headline}</T>
        </ImageCarouselComponentHeadline>
      )}

      <PDPDownloadElements elements={props.elements} />
    </ContentContainer>
  );
}
